import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { User } from '@api/models/UserService/Contract/user';
import { RoutingQueryParamsName } from '@core/router/routing.params';
import { isNil } from 'lodash-es';
import { UsersState } from '../../state/users.state';


@Injectable({
    providedIn: 'root',
})
export class UserDetailResolverService {
    readonly #usersState: UsersState = inject(UsersState);

    public resolve(
        route: ActivatedRouteSnapshot,
    ): Observable<User> | Observable<never> {
        const usrId: number = +route.paramMap.get(RoutingQueryParamsName.UsrId);

        return isNil(usrId) || usrId === 0 ? null : this.#usersState.requestUserData(usrId).pipe(take(1));
    }
}
